export interface ComicChapter {
  id: string;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  description: string;
  coverImage: string;
  rating: number;
  views: number;
  followers: number;
  updateDate: string;
  chapters: ComicChapter[];
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '动作', slug: 'action' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '悬疑', slug: 'mystery' },
  { name: '喜剧', slug: 'comedy' },
  { name: '剧情', slug: 'drama' },
  { name: '恐怖', slug: 'horror' },
  { name: 'BL', slug: 'bl' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '我独自升级',
    author: 'Chugong / DUBU（REDICE STUDIO）',
    category: '动作',
    categorySlug: 'action',
    tags: ['热血', '奇幻', '逆袭'],
    status: '已完结',
    description: '十年前，世界各地突然出现了连接异次元与这个世界的「门」，而其中觉醒的人类被称为「猎人」。在这个弱肉强食的世界里，被称为人类最弱兵器的E级猎人成振宇，在一次地下城探索中遭遇了生死危机后，突然获得了一个神秘的系统，能够让他每天升级变强。从一个最弱小的猎人，逐步成长为人类最强的存在...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20art%20style%2C%20a%20powerful%20male%20protagonist%20with%20dark%20hair%20and%20glowing%20purple%20eyes%2C%20holding%20a%20dagger%2C%20dark%20atmospheric%20background%20with%20magical%20particles%2C%20dynamic%20action%20pose%2C%20clean%20illustration%20style%2C%20vibrant%20colors%20on%20a%20simple%20background%2C%20professional%20comic%20art&width=400&height=560&seq=comic-1-cover&orientation=portrait',
    rating: 9.7,
    views: 28560000,
    followers: 1250000,
    updateDate: '2025-12-20',
    chapters: [
      { id: 'ch-1-1', title: '第179话 终章', updateDate: '2025-12-20' },
      { id: 'ch-1-2', title: '第178话 最后的战斗', updateDate: '2025-12-13' },
      { id: 'ch-1-3', title: '第177话 觉醒', updateDate: '2025-12-06' },
      { id: 'ch-1-4', title: '第176话 决战前夕', updateDate: '2025-11-29' },
      { id: 'ch-1-5', title: '第175话 王的归来', updateDate: '2025-11-22' },
    ],
  },
  {
    id: 'comic-2',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['穿越', '悬疑', '系统'],
    status: '连载中',
    description: '金独子是唯一一个读完了长达3149话的网络小说《在灭亡的世界中生存的三种方法》的读者。当小说中的世界突然变成现实，他发现自己成为了唯一知道这个世界结局的人。凭借对小说的全知全能，金独子开始了在这个末日世界中的生存之旅...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20art%2C%20a%20young%20man%20with%20glasses%20and%20dark%20hair%2C%20holding%20an%20ancient%20book%20with%20glowing%20symbols%2C%20apocalyptic%20city%20background%20with%20subtle%20warm%20tones%2C%20mysterious%20atmosphere%2C%20clean%20and%20modern%20comic%20illustration%20style%2C%20simple%20composition&width=400&height=560&seq=comic-2-cover&orientation=portrait',
    rating: 9.8,
    views: 32100000,
    followers: 1580000,
    updateDate: '2026-01-05',
    chapters: [
      { id: 'ch-2-1', title: '第228话 最后的篇章', updateDate: '2026-01-05' },
      { id: 'ch-2-2', title: '第227话 真相大白', updateDate: '2025-12-28' },
      { id: 'ch-2-3', title: '第226话 命运的选择', updateDate: '2025-12-21' },
      { id: 'ch-2-4', title: '第225话 幕后之人', updateDate: '2025-12-14' },
      { id: 'ch-2-5', title: '第224话 星空之下', updateDate: '2025-12-07' },
    ],
  },
  {
    id: 'comic-3',
    title: '再婚皇后',
    author: 'Alphatart / Sumpul',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['宫廷', '逆袭', '女性向'],
    status: '连载中',
    description: '娜维埃是东方帝国的完美皇后，她拥有美貌、智慧与人民的热爱。然而她的丈夫——皇帝索本修却突然带回了一个身份不明的女子，并宣布要立她为妃。面对突如其来的变故，娜维埃做出了一个惊天决定：与皇帝离婚，接受邻国王子的求婚，成为他国的皇后。一个关于尊严、复仇与真爱的宫廷浪漫故事就此展开...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20romance%20manhwa%20cover%2C%20an%20elegant%20queen%20with%20long%20blonde%20hair%20wearing%20a%20luxurious%20royal%20gown%2C%20golden%20palace%20background%20with%20soft%20lighting%2C%20romantic%20and%20regal%20atmosphere%2C%20clean%20illustration%20style%2C%20warm%20color%20palette%2C%20simple%20elegant%20composition&width=400&height=560&seq=comic-3-cover&orientation=portrait',
    rating: 9.5,
    views: 19800000,
    followers: 980000,
    updateDate: '2026-01-08',
    chapters: [
      { id: 'ch-3-1', title: '第156话 新的开始', updateDate: '2026-01-08' },
      { id: 'ch-3-2', title: '第155话 邻国王子', updateDate: '2026-01-01' },
      { id: 'ch-3-3', title: '第154话 决裂', updateDate: '2025-12-25' },
      { id: 'ch-3-4', title: '第153话 宴会风波', updateDate: '2025-12-18' },
    ],
  },
  {
    id: 'comic-4',
    title: '外貌至上主义',
    author: '朴泰俊',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['校园', '成长', '社会'],
    status: '连载中',
    description: '朴亨硕是一个因为长相丑陋而长期遭受校园霸凌的高中生。在绝望之际，他转学到了另一所学校，却意外发现自己拥有了一个完美的身体——一个高大帅气的新身份。白天他以帅气的外表生活，夜晚回到原本丑陋的身体。通过两个截然不同的视角，他看到了这个以外貌评判一切的社会最真实的一面...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20cover%20art%2C%20a%20split%20face%20composition%20showing%20contrast%20between%20two%20identities%20of%20a%20young%20man%2C%20one%20handsome%20and%20one%20ordinary%2C%20school%20locker%20background%2C%20emotional%20and%20thought-provoking%20atmosphere%2C%20clean%20modern%20comic%20illustration%2C%20simple%20composition&width=400&height=560&seq=comic-4-cover&orientation=portrait',
    rating: 9.3,
    views: 16500000,
    followers: 720000,
    updateDate: '2026-01-02',
    chapters: [
      { id: 'ch-4-1', title: '第412话 新的敌人', updateDate: '2026-01-02' },
      { id: 'ch-4-2', title: '第411话 真相', updateDate: '2025-12-26' },
      { id: 'ch-4-3', title: '第410话 对决', updateDate: '2025-12-19' },
    ],
  },
  {
    id: 'comic-5',
    title: '神之塔',
    author: 'SIU',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['冒险', '友情', '谜题'],
    status: '连载中',
    description: '第二十五夜是一个生活在巨大塔楼底部的少年，他唯一的朋友是一位名叫蕾哈尔的女孩。当蕾哈尔为了追寻塔顶的星空而进入塔内后，夜也追随她踏上了攀登神之塔的旅程。在这座充满了神秘、危险与考验的塔中，每一层都是一个世界，而塔顶据说可以实现任何愿望...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20captivating%20Korean%20fantasy%20manhwa%20cover%2C%20a%20young%20boy%20with%20brown%20hair%20climbing%20a%20massive%20mysterious%20tower%2C%20magical%20blue%20energy%20surrounding%20him%2C%20epic%20scale%20with%20floating%20platforms%2C%20adventure%20atmosphere%2C%20clean%20comic%20art%20style%2C%20simple%20composition%20with%20dramatic%20lighting&width=400&height=560&seq=comic-5-cover&orientation=portrait',
    rating: 9.6,
    views: 24500000,
    followers: 1100000,
    updateDate: '2026-01-10',
    chapters: [
      { id: 'ch-5-1', title: '第587话 塔的真相', updateDate: '2026-01-10' },
      { id: 'ch-5-2', title: '第586话 家族之战', updateDate: '2026-01-03' },
      { id: 'ch-5-3', title: '第585话 新的盟友', updateDate: '2025-12-27' },
    ],
  },
  {
    id: 'comic-6',
    title: '甜蜜蜜',
    author: '金美英',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['甜宠', '日常', '治愈'],
    status: '已完结',
    description: '从高中时代就暗恋彼此的尹秀和智恩，因为一次偶然的误会错过了彼此。十年后，两人在职场重逢，当年的青涩感情是否还在？一段温暖治愈的都市爱情故事，带你重温初恋的甜蜜与悸动...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20romance%20manhwa%20cover%2C%20a%20young%20couple%20sharing%20a%20tender%20moment%20in%20a%20cozy%20cafe%2C%20soft%20pastel%20color%20palette%20with%20warm%20lighting%2C%20cherry%20blossom%20petals%20floating%2C%20romantic%20and%20heartwarming%20atmosphere%2C%20clean%20illustration%20style%2C%20simple%20sweet%20composition&width=400&height=560&seq=comic-6-cover&orientation=portrait',
    rating: 9.2,
    views: 8900000,
    followers: 450000,
    updateDate: '2025-11-15',
    chapters: [
      { id: 'ch-6-1', title: '第98话 结局（下）', updateDate: '2025-11-15' },
      { id: 'ch-6-2', title: '第97话 结局（上）', updateDate: '2025-11-08' },
      { id: 'ch-6-3', title: '第96话 告白', updateDate: '2025-11-01' },
    ],
  },
  {
    id: 'comic-7',
    title: '杀手来信',
    author: '李宰汉',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['犯罪', '推理', '心理'],
    status: '连载中',
    description: '首尔江南区发生了一起离奇的连环杀人案。犯罪心理分析师韩智浩在调查过程中，发现每次案发前，自己都会收到一封来自凶手的预告信。随着调查的深入，他发现凶手似乎与自己的过去有着千丝万缕的联系...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20thrilling%20Korean%20mystery%20manhwa%20cover%2C%20a%20detective%20in%20trench%20coat%20holding%20a%20cryptic%20letter%2C%20dark%20rainy%20Seoul%20street%20background%20with%20neon%20reflections%2C%20tense%20and%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20clean%20comic%20illustration%2C%20simple%20dramatic%20composition&width=400&height=560&seq=comic-7-cover&orientation=portrait',
    rating: 9.1,
    views: 7500000,
    followers: 380000,
    updateDate: '2026-01-03',
    chapters: [
      { id: 'ch-7-1', title: '第87话 真相', updateDate: '2026-01-03' },
      { id: 'ch-7-2', title: '第86话 最后通牒', updateDate: '2025-12-27' },
      { id: 'ch-7-3', title: '第85话 追踪', updateDate: '2025-12-20' },
    ],
  },
  {
    id: 'comic-8',
    title: '女神降临',
    author: 'Yaongyi',
    category: '喜剧',
    categorySlug: 'comedy',
    tags: ['化妆', '校园', '爱情'],
    status: '已完结',
    description: '林珠静是一个因为长相平凡而在学校备受欺负的女孩。通过精湛的化妆技术，她摇身一变成为校园中的女神。然而她最大的秘密就是不能让任何人看到素颜的自己。当学校里最帅的两个男生同时注意到她时，一场关于外貌、自信与真爱的爆笑校园喜剧就此展开...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20comedy%20manhwa%20cover%2C%20a%20pretty%20girl%20with%20makeup%20brushes%20surrounded%20by%20cosmetics%2C%20bright%20and%20colorful%20school%20background%2C%20humorous%20and%20lighthearted%20vibe%2C%20clean%20comic%20illustration%20style%2C%20vibrant%20colors%20on%20simple%20composition&width=400&height=560&seq=comic-8-cover&orientation=portrait',
    rating: 9.0,
    views: 15200000,
    followers: 680000,
    updateDate: '2025-10-30',
    chapters: [
      { id: 'ch-8-1', title: '第247话 真正的女神', updateDate: '2025-10-30' },
      { id: 'ch-8-2', title: '第246话 最后的选择', updateDate: '2025-10-23' },
      { id: 'ch-8-3', title: '第245话 素颜', updateDate: '2025-10-16' },
    ],
  },
  {
    id: 'comic-9',
    title: '甜蜜家园',
    author: '金坎比 / 黄英灿',
    category: '恐怖',
    categorySlug: 'horror',
    tags: ['末日', '怪物', '生存'],
    status: '已完结',
    description: '因校园暴力而封闭自我的车贤秀，在失去家人后搬到了一栋破旧的公寓楼中独自生活。然而世界突然爆发了一场可怕的灾难——人类开始变异成恐怖的怪物，反映着每个人内心最深处的欲望。被孤立在公寓中的居民们必须团结起来，在绝境中求生...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20horror%20manhwa%20cover%2C%20a%20young%20man%20with%20a%20monstrous%20shadow%20looming%20behind%20him%2C%20dilapidated%20apartment%20building%20in%20darkness%2C%20eerie%20and%20tense%20atmosphere%20with%20red%20accents%2C%20clean%20comic%20illustration%20style%2C%20simple%20but%20unnerving%20composition&width=400&height=560&seq=comic-9-cover&orientation=portrait',
    rating: 9.4,
    views: 18200000,
    followers: 850000,
    updateDate: '2025-09-20',
    chapters: [
      { id: 'ch-9-1', title: '第141话 结局', updateDate: '2025-09-20' },
      { id: 'ch-9-2', title: '第140话 最后的希望', updateDate: '2025-09-13' },
      { id: 'ch-9-3', title: '第139话 牺牲', updateDate: '2025-09-06' },
    ],
  },
  {
    id: 'comic-10',
    title: '剑尊归来',
    author: '柳成珉 / 李贤民',
    category: '动作',
    categorySlug: 'action',
    tags: ['武侠', '重生', '逆袭'],
    status: '连载中',
    description: '天下第一剑——梅华剑尊赵杰，在与魔教教主的最终决战中同归于尽。然而当他再次睁开眼时，发现自己回到了二十年前，那个他尚未成名、家破人亡的少年时代。带着前世的记忆与剑术，他决心改变一切，保护所爱之人，并让那些曾经伤害过他的人付出代价...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20martial%20arts%20manhwa%20cover%2C%20a%20swordsman%20with%20long%20dark%20hair%20in%20traditional%20robes%2C%20wielding%20a%20glowing%20sword%2C%20ancient%20Korean%20palace%20background%20with%20cherry%20blossoms%2C%20epic%20and%20heroic%20atmosphere%2C%20clean%20comic%20art%2C%20simple%20powerful%20composition&width=400&height=560&seq=comic-10-cover&orientation=portrait',
    rating: 9.5,
    views: 21300000,
    followers: 950000,
    updateDate: '2026-01-12',
    chapters: [
      { id: 'ch-10-1', title: '第132话 剑尊之名', updateDate: '2026-01-12' },
      { id: 'ch-10-2', title: '第131话 宿命对决', updateDate: '2026-01-05' },
      { id: 'ch-10-3', title: '第130话 回忆', updateDate: '2025-12-29' },
    ],
  },
  {
    id: 'comic-11',
    title: '她的私生活',
    author: '金成妍',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['职场', '追星', '秘密'],
    status: '连载中',
    description: '成德美白天是美术馆的首席策展人，干练专业。然而到了晚上，她就化身为顶级偶像车时安的狂热粉丝，经营着一个拥有数十万关注者的粉丝站。当新任馆长莱恩·金走进她的生活，她必须小心翼翼地隐藏自己这个秘密身份...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20romance%20manhwa%20cover%2C%20a%20professional%20woman%20in%20elegant%20office%20attire%20secretly%20holding%20a%20fan%20light%20stick%20behind%20her%20back%2C%20modern%20art%20gallery%20background%2C%20playful%20and%20romantic%20atmosphere%2C%20clean%20comic%20illustration%2C%20simple%20charming%20composition&width=400&height=560&seq=comic-11-cover&orientation=portrait',
    rating: 8.9,
    views: 6800000,
    followers: 320000,
    updateDate: '2026-01-06',
    chapters: [
      { id: 'ch-11-1', title: '第78话 秘密暴露', updateDate: '2026-01-06' },
      { id: 'ch-11-2', title: '第77话 危机', updateDate: '2025-12-30' },
      { id: 'ch-11-3', title: '第76话 约会', updateDate: '2025-12-23' },
    ],
  },
  {
    id: 'comic-12',
    title: '鬼怪',
    author: '金银淑 / 崔正元',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['鬼神', '爱情', '宿命'],
    status: '已完结',
    description: '拥有不死之身的高丽时期大将军金信，被神诅咒成为不死不灭的鬼怪。九百多年来，他一直在寻找能够拔下他胸口那把看不见的剑的鬼怪新娘，只有她才能让他安息。当他遇到了自称能看见鬼魂的高中生池恩倬时，一段跨越生死的奇幻爱情故事徐徐展开...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20fantasy%20romance%20manhwa%20cover%2C%20an%20immortal%20being%20with%20a%20sword%20piercing%20his%20chest%2C%20standing%20in%20an%20ancient%20Korean%20landscape%20with%20autumn%20leaves%2C%20mystical%20and%20melancholic%20atmosphere%2C%20clean%20comic%20illustration%2C%20simple%20emotional%20composition&width=400&height=560&seq=comic-12-cover&orientation=portrait',
    rating: 9.6,
    views: 20500000,
    followers: 1020000,
    updateDate: '2025-08-15',
    chapters: [
      { id: 'ch-12-1', title: '第168话 永远的约定', updateDate: '2025-08-15' },
      { id: 'ch-12-2', title: '第167话 鬼怪新娘', updateDate: '2025-08-08' },
      { id: 'ch-12-3', title: '第166话 神的意志', updateDate: '2025-08-01' },
    ],
  },
];

export const featuredComicIds = ['comic-1', 'comic-2', 'comic-10', 'comic-5', 'comic-3'];

export const hotComicIds = ['comic-2', 'comic-1', 'comic-5', 'comic-10', 'comic-3', 'comic-9'];

export const newUpdateIds = ['comic-10', 'comic-3', 'comic-2', 'comic-5', 'comic-7', 'comic-11'];